import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { commonApi } from 'core/api/common.api';
import { setAxiosAuth } from 'utils';
import { LocationHoursProps } from './types';

export const useGetLocationHours = ({
  id,
  accessToken = '',
  enabled = true,
}: LocationHoursProps) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.locationHours, id],
    queryFn: async () => await commonApi.getLocationHours(id,'STAFF'),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken && id) && enabled,
  });
}
